<template>
  <div class="chart-container d-flex flex-column justify-content-center align-items-center"
       style="height: 300px; width: 100%;">
    <span class="chart-mean">Mean: {{mean && mean.toFixed(2)}}</span>
    <div class="chart-canvas-wrapper">
      <HorizontalBarChart
        class="chart-canvas"
        :options="options"
        :chart-data="data"
      ></HorizontalBarChart>
    </div>
  </div>
</template>

<script>
import HorizontalBarChart from './HorizontalBarChart'
import tooltips from '../../constants/tooltips'
import { buildExternalTooltip } from './chartTooltip'

export default {
  name: 'HorizontalAnalyticsChart',
  components: { HorizontalBarChart },
  props: {
    data: Object,
    max: {
      type: Number,
      required: false
    },
    mean: {
      type: Number,
      required: false
    },
    nValues: Array
  },
  data () {
    return {
      options: {
        scales: {
          x: {
            grid: {
              display: true
            },
            beginAtZero: true,
            min: 0,
            max: this.max
          },
          y: {
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            labels: {
              font: {
                family: '\'Open Sans\', sans-serif'
              }
            }
          },
          tooltip: {
            enabled: false,
            external: buildExternalTooltip(),
            callbacks: {
              label: (context) => {
                const dataType = context.dataset && context.dataset.label
                const parsedValue = context.parsed && typeof context.parsed.x === 'number'
                  ? context.parsed.x
                  : Number(context.raw)
                const value = Number.isFinite(parsedValue) ? parsedValue.toFixed(2) : '-'
                const aggregationLabel = String(context.label || '')
                const aggregationType = aggregationLabel.replace(/ /g, '_').toLowerCase()
                const nCountValue = this.nValues && this.nValues.length
                  ? (this.nValues.find(el =>
                    aggregationLabel === 'Neutral'
                      ? el.key.includes('just_right')
                      : el.key.includes(aggregationType)
                  ) || {}).value || 0
                  : 0
                const nCount = `n = ${nCountValue}`
                const score = `Score = ${value}%`
                const tooltipKey = ['Strength', 'Liking', 'Purchase intent'].includes(dataType)
                  ? dataType.replace(/ /g, '_').toLowerCase()
                  : 'attribute'
                const tooltipGroup = tooltips[`chart_${tooltipKey}`] || []
                const tooltipData = tooltipGroup.find(el => el.key === aggregationType)
                return [score, nCount, tooltipData ? tooltipData.text : '']
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.chart-container {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  justify-content: flex-start !important;
  box-sizing: border-box;
  padding: 4px 0;
}

.chart-mean {
  line-height: 20px;
}

.chart-canvas-wrapper {
  width: 100%;
  flex: 1;
  min-height: 0;
  padding: 6px 10px 0;
  box-sizing: border-box;
}

.chart-canvas-wrapper :deep(canvas) {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}
</style>
